const state = {
	connectado: false,
	mensajes: [],
	error: null,
	aspirantes: [],
	count: 0,
	limit: 5,
	mensajesEnviados: 0,
	detalleMensajes: []
};

const getters = {
	displayMessages: (state) => state.mensajes,
	getAspirantes: (state) => state.aspirantes
};

const actions = {
	addMessage({ commit }, message) {
		commit('ADD_MESSAGE', message);
	},
	openConnection({ commit }) {
		commit('OPEN_CONNECTION', true);
	},
	connectionOpened({ commit }) {
		commit('SET_CONNECTION', true);
	},
	connectionClosed({ commit }) {
		commit('SET_CONNECTION', false);
	},
	connectionError({ commit }, error) {
		commit('SET_ERROR', error);
	},
	iniciar({ commit }, message) {
		commit('INICIAR', message);
	},
	HearthBeat({ commit }) {
		commit('HB');
	},
	AspiranteHB({ commit }, payload) {
		commit('ASPIRANTEHB', payload);
	},
	EnviarMensaje({ commit }, payload) {
		commit('ENVIARMENSAJE', payload);
	},
	Avance({ commit, dispatch }, payload) {
		commit('AVANCE', payload);
	},
	NuevoVideo({ commit, dispatch }, payload) {
		commit('NUEVOVIDEO', payload);
		dispatch('PlayNext', payload);
	},
	PlayNext({ commit, state }, payload) {
		// let {folio, url, tipo} = payload;
		commit('PLAYNEXT', payload);
	},
	BloquearAspirante({ commit }, payload) {
		commit('BLOQUEARASPIRANTE', payload);
	},
	Desconectar({ commit }, folio) {
		commit('DESCONECTAR', folio);
	},
	saltoPregunta({ commit }, folio) {
		commit('SALTO', folio);
	},
	EstadoAspirante({ commit }, payload) {
		commit('ESTADO_ASPIRANTE', payload);
	},
	PreguntaActual({ commit }, payload) {
		commit('PREGUNTA_ACTUAL', payload);
	},
	EstadoExamen({ commit }, payload) {
		commit('ESTADO_EXAMEN', payload);
	}
};

const mutations = {
	ADD_MESSAGE(state, message) {
		while (state.mensajes.length >= state.limit) {
			state.mensajes.shift();
		}
		state.mensajes.push(message);
	},

	SET_CONNECTION(state, message) {
		state.connectado = message;
	},
	SET_ERROR(state, error) {
		state.error = error;
	},
	// forwar to ws
	OPEN_CONNECTION(state, message) {},
	INICIAR(state, hr) {},
	HB(state, hr) {},
	BLOQUEARASPIRANTE(state, payload) {},

	ENVIARMENSAJE(state, payload) {},

	// from websocket
	ASPIRANTEHB(state, { folio, ts }) {
		const existe = state.aspirantes.find((el) => el.folio === folio);
		var fecha = new Date(parseInt(ts));
		var texto = `${fecha.getHours()}:${fecha.getSeconds()}`;
		if (!existe) {
			state.aspirantes.push({
				folio: folio,
				ts: texto,
				mensaje: '',
				video: '',
				preguntasSaltadas: 0,
				videoScreen: '',
				videos: []
			});
		} else {
			existe.ts = texto;
		}
	},
	AVANCE(state, { folio, avance }) {
		const aspirante = state.aspirantes.find((el) => el.folio === folio);
		if (aspirante) {
			const mensaje = JSON.parse(avance);
			console.log('avance del  ws --> ', mensaje);
			aspirante.areaDeConocimientoActual = mensaje.areaDeConocimientoActual;
			aspirante.fechaYHoraInicio = mensaje.fechaYHoraInicio;
			aspirante.preguntaActual = mensaje.preguntaActual;
			aspirante.seccionActual = mensaje.seccionActual;
			// aspirante.totalPreguntas = mensaje.totalPreguntas || 0;
			// aspirante.numPreguntaActual = mensaje.numeroPreguntaActual || 0;
		}
	},
	NUEVOVIDEO(state, { folio, url, tipo }) {
		const aspirante = state.aspirantes.find((el) => el.folio === folio);
		if (aspirante) {
			if (tipo === 'Screen') aspirante.videoScreen = url;
			else if (tipo === 'Camara') aspirante.video = url;
		}
	},

	PLAYNEXT(state, { folio, url, tipo }) {
		const aspirante = state.aspirantes.find((el) => el.folio === folio);
		if (aspirante) {
			if (tipo === 'Screen') aspirante.videoScreen = url;
			else if (tipo === 'Camara') aspirante.video = url;
		}
	},
	DESCONECTAR(state, { folio }) {
		state.aspirantes = [...state.aspirantes.filter((x) => x.folio !== folio)];
	},
	SALTO(state, { folio, totalSaltadas }) {
		const aspirante = state.aspirantes.find((el) => el.folio === folio);
		if (aspirante) {
			aspirante.preguntasSaltadas = totalSaltadas;
		}
	},
	ESTADO_ASPIRANTE(
		state,
		{
			ficha,
			numeroMensajes,
			listaMensajes,
			preguntaActual,
			totalPreguntas,
			finalizoExamen
		}
	) {
		const aspirante = state.aspirantes.find((el) => el.folio === ficha);
		if (aspirante) {
			aspirante.mensajesEnviados = numeroMensajes;
			aspirante.detalleMensajes = listaMensajes;
			// aspirante.totalPreguntas = totalPreguntas;
			aspirante.finalizoExamen = finalizoExamen;
		}
	},
	PREGUNTA_ACTUAL(state, { folio, preguntaActual }) {
		const aspirante = state.aspirantes.find((el) => el.folio === folio);
		if (aspirante) {
			aspirante.numPreguntaActual = preguntaActual;
		}
	},
	ESTADO_EXAMEN(state, { folio, totalPreguntas, finalizoExamen }) {
		const aspirante = state.aspirantes.find((el) => el.folio === folio);
		if (aspirante) {
			// aspirante.totalPreguntas = totalPreguntas;
			aspirante.finalizoExamen = finalizoExamen;
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
